import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Alert } from '../models/alert-class';
import {
  CustomerApprovalRequestsClass,
  CustomerCAEClass,
  CustomerClass,
  CustomerContactMethodsClass,
  CustomerContactsClass,
  CustomerContactsDefault,
  CustomerCookiesAlertClass,
  CustomerEmail,
  CustomerFavoriteProposalsClass,
  CustomerInterests,
  CustomerLayoutClass,
  CustomerNIB,
  CustomerNIFAutorizationClass,
  CustomerRedFlagClass,
  CustomerRedFlagTypeClass,
  CustomerScheduleClass,
  CustomerSendInvitationClass,
  CustomerShipToAddressClass,
  CustomerSubscribeDiscountsAdvantages,
} from '../models/customer-class';
import { FilesClass } from '../models/uploads-class';
import { HttpclienterrorService } from '../interceptor/httpclienterror.service';
import { CrmCacheService, CrmSwrOptions } from './crm-cache.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  constructor(
    private http: HttpClient,
    public httpclienterrorService: HttpclienterrorService,
    private crmCache: CrmCacheService,
  ) {}

  ClientAreaSetCustomerApprovalRequests(
    customerApprovalRequestsClass: CustomerApprovalRequestsClass,
    uuid: string,
  ): Observable<CustomerApprovalRequestsClass[]> {
    customerApprovalRequestsClass.UUIDLastChange = uuid;

    return this.http
      .post<
        CustomerApprovalRequestsClass[]
      >(environment.URL + `/Customer/ClientAreaSetCustomerApprovalRequests`, customerApprovalRequestsClass)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaGetCustomerApprovalRequests(Code: string): Observable<CustomerApprovalRequestsClass[]> {
    return this.http
      .get<CustomerApprovalRequestsClass[]>(environment.URL + `/Customer/ClientAreaGetCustomerApprovalRequests/${Code}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetCustomerCookiesAlert(idCustomer: number): Observable<CustomerCookiesAlertClass[]> {
    return this.http
      .get<CustomerCookiesAlertClass[]>(environment.URL + `/Customer/GetCustomerCookiesAlert/${idCustomer}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  SetCustomerCookiesAlert(
    customerCookiesAlertClass: CustomerCookiesAlertClass,
    uuid: string,
  ): Observable<CustomerCookiesAlertClass[]> {
    customerCookiesAlertClass.UUIDLastChange = uuid;

    return this.http
      .post<
        CustomerCookiesAlertClass[]
      >(environment.URL + `/Customer/SetCustomerCookiesAlert`, customerCookiesAlertClass)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  SetCustomerSendInvitation(
    customerSendInvitationClass: CustomerSendInvitationClass,
    uuid: string,
  ): Observable<CustomerSendInvitationClass[]> {
    customerSendInvitationClass.UUIDLastChange = uuid;

    return this.http
      .post<
        CustomerSendInvitationClass[]
      >(environment.URL + `/Customer/SetCustomerSendInvitation`, customerSendInvitationClass)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaSetCustomerFavoriteProposals(
    customerFavoriteProposalsClass: CustomerFavoriteProposalsClass,
    uuid: string,
  ): Observable<CustomerFavoriteProposalsClass[]> {
    customerFavoriteProposalsClass.UUIDLastChange = uuid;

    return this.http
      .post<
        CustomerFavoriteProposalsClass[]
      >(environment.URL + `/Customer/ClientAreaSetCustomerFavoriteProposals`, customerFavoriteProposalsClass)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaGetCustomerFavoriteProposals(idCustomer: number): Observable<CustomerFavoriteProposalsClass[]> {
    return this.http
      .get<
        CustomerFavoriteProposalsClass[]
      >(environment.URL + `/Customer/ClientAreaGetCustomerFavoriteProposals/${idCustomer}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaSetSubscribeDiscountsAdvantagesByEmail(
    customerSubscribeDiscountsAdvantages: CustomerSubscribeDiscountsAdvantages,
    uuid: string,
  ): Observable<CustomerSubscribeDiscountsAdvantages[]> {
    customerSubscribeDiscountsAdvantages.UUIDLastChange = uuid;

    return this.http
      .post<
        CustomerSubscribeDiscountsAdvantages[]
      >(environment.URL + `/Customer/ClientAreaSetSubscribeDiscountsAdvantagesByEmail`, customerSubscribeDiscountsAdvantages)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaSetSubscribeDiscountsAdvantages(
    customerSubscribeDiscountsAdvantages: CustomerSubscribeDiscountsAdvantages,
    uuid: string,
  ): Observable<CustomerSubscribeDiscountsAdvantages[]> {
    customerSubscribeDiscountsAdvantages.UUIDLastChange = uuid;

    return this.http
      .post<
        CustomerSubscribeDiscountsAdvantages[]
      >(environment.URL + `/Customer/ClientAreaSetSubscribeDiscountsAdvantages`, customerSubscribeDiscountsAdvantages)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaGetSubscribeDiscountsAdvantagesALL(): Observable<CustomerSubscribeDiscountsAdvantages[]> {
    return this.http
      .get<
        CustomerSubscribeDiscountsAdvantages[]
      >(environment.URL + `/Customer/ClientAreaGetSubscribeDiscountsAdvantagesALL/`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaSetCustomerSchedule(
    customerScheduleClass: CustomerScheduleClass,
    uuid: string,
  ): Observable<CustomerScheduleClass[]> {
    customerScheduleClass.UUIDLastChange = uuid;

    return this.http
      .post<CustomerScheduleClass[]>(environment.URL + `/Customer/ClientAreaSetCustomerSchedule`, customerScheduleClass)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaGetCustomerSchedule(idCustomer: number): Observable<CustomerScheduleClass[]> {
    return this.http
      .get<CustomerScheduleClass[]>(environment.URL + `/Customer/ClientAreaGetCustomerSchedule/${idCustomer}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaGetCustomerNIFAutorizationMyNIFNOT(idCustomer: number): Observable<CustomerNIFAutorizationClass[]> {
    return this.http
      .get<
        CustomerNIFAutorizationClass[]
      >(environment.URL + `/Customer/ClientAreaGetCustomerNIFAutorizationMyNIFNOT/${idCustomer}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaGetCustomerNIFAutorizationMyNIF(idCustomer: number): Observable<CustomerNIFAutorizationClass[]> {
    return this.http
      .get<
        CustomerNIFAutorizationClass[]
      >(environment.URL + `/Customer/ClientAreaGetCustomerNIFAutorizationMyNIF/${idCustomer}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaGetCustomerNIFAutorizationMyNIFAll(idCustomer: number): Observable<CustomerNIFAutorizationClass[]> {
    return this.http
      .get<
        CustomerNIFAutorizationClass[]
      >(environment.URL + `/Customer/ClientAreaGetCustomerNIFAutorizationMyNIFAll/${idCustomer}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaSetCustomerNIFAutorization(
    customerNIFAutorizationClass: CustomerNIFAutorizationClass,
    uuid: string,
  ): Observable<CustomerNIFAutorizationClass[]> {
    customerNIFAutorizationClass.UUIDLastChange = uuid;

    return this.http
      .post<
        CustomerNIFAutorizationClass[]
      >(environment.URL + `/Customer/ClientAreaSetCustomerNIFAutorization`, customerNIFAutorizationClass)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaGetCustomerNIFAutorizationPending(idCustomer: number): Observable<CustomerNIFAutorizationClass[]> {
    return this.http
      .get<
        CustomerNIFAutorizationClass[]
      >(environment.URL + `/Customer/ClientAreaGetCustomerNIFAutorizationPending/${idCustomer}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaGetCustomerNIFid(idCustomerNIFPermission: number): Observable<CustomerNIFAutorizationClass[]> {
    return this.http
      .get<
        CustomerNIFAutorizationClass[]
      >(environment.URL + `/Customer/ClientAreaGetCustomerNIFid/${idCustomerNIFPermission}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaGetCustomerNIFAutorization(
    idCustomer: number,
    Autorized: number,
  ): Observable<CustomerNIFAutorizationClass[]> {
    return this.http
      .get<
        CustomerNIFAutorizationClass[]
      >(environment.URL + `/Customer/ClientAreaGetCustomerNIFAutorization/${idCustomer}/${Autorized}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaGetCustomerNIFAutorizationAll(idCustomer: number): Observable<CustomerNIFAutorizationClass[]> {
    return this.http
      .get<
        CustomerNIFAutorizationClass[]
      >(environment.URL + `/Customer/ClientAreaGetCustomerNIFAutorizationAll/${idCustomer}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaSetCustomerInterests(customerInterests: CustomerInterests, uuid: string): Observable<CustomerInterests[]> {
    customerInterests.UUIDLastChange = uuid;

    return this.http
      .post<CustomerInterests[]>(environment.URL + `/Customer/ClientAreaSetCustomerInterests`, customerInterests)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaGetCustomerInterests(idCustomer: number): Observable<CustomerInterests[]> {
    return this.http
      .get<CustomerInterests[]>(environment.URL + `/Customer/ClientAreaGetCustomerInterests/${idCustomer}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaGetCustomerLayout(idCustomer: number): Observable<CustomerLayoutClass[]> {
    return this.http
      .get<CustomerLayoutClass[]>(environment.URL + `/Customer/ClientAreaGetCustomerLayout/${idCustomer}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaSetCustomerNIB(customerNIB: CustomerNIB, uuid: string): Observable<CustomerNIB[]> {
    customerNIB.UUIDLastChange = uuid;
    if (customerNIB?.idCustomer) {
      this.crmCache.invalidate(`cust_nib:${customerNIB.idCustomer}`);
      this.crmCache.invalidate(`cust_detail:${customerNIB.idCustomer}`);
    }

    return this.http.post<CustomerNIB[]>(environment.URL + `/Customer/ClientAreaSetCustomerNIB`, customerNIB).pipe(
      tap(() => {
        if (customerNIB?.idCustomer) {
          this.crmCache.invalidate(`cust_nib:${customerNIB.idCustomer}`);
          this.crmCache.invalidate(`cust_detail:${customerNIB.idCustomer}`);
        }
      }),
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  ClientAreaGetCustomerNIB(idCustomer: number, options?: CrmSwrOptions): Observable<CustomerNIB[]> {
    return this.crmCache.swr(
      `cust_nib:${idCustomer}`,
      () =>
        this.http.get<CustomerNIB[]>(environment.URL + `/Customer/ClientAreaGetCustomerNIB/${idCustomer}`).pipe(
          catchError(error => {
            const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
            return throwError(() => errorMessage);
          }),
        ),
      { persist: false, silentPrefetch: true, ...options },
    );
  }

  ClientAreaSetCustomerEmail(customerEmail: CustomerEmail, uuid: string): Observable<CustomerEmail[]> {
    customerEmail.UUIDLastChange = uuid;
    if (customerEmail?.idCustomer) {
      this.crmCache.invalidate(`cust_detail:${customerEmail.idCustomer}`);
    }

    return this.http
      .post<CustomerEmail[]>(environment.URL + `/Customer/ClientAreaSetCustomerEmail`, customerEmail)
      .pipe(
        tap(() => {
          if (customerEmail?.idCustomer) {
            this.crmCache.invalidate(`cust_detail:${customerEmail.idCustomer}`);
          }
        }),
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaGetCustomerEmails(idCustomer: number): Observable<CustomerEmail[]> {
    return this.http.get<CustomerEmail[]>(environment.URL + `/Customer/ClientAreaGetCustomerEmails/${idCustomer}`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  ClientAreaSetCustomerCAE(customerCAEClass: CustomerCAEClass, uuid: string): Observable<CustomerCAEClass[]> {
    customerCAEClass.UUIDLastChange = uuid;
    if (customerCAEClass?.idCustomer) {
      this.crmCache.invalidate(`cust_cae:${customerCAEClass.idCustomer}`);
      this.crmCache.invalidate(`cust_detail:${customerCAEClass.idCustomer}`);
    }

    return this.http
      .post<CustomerCAEClass[]>(environment.URL + `/Customer/ClientAreaSetCustomerCAE`, customerCAEClass)
      .pipe(
        tap(() => {
          if (customerCAEClass?.idCustomer) {
            this.crmCache.invalidate(`cust_cae:${customerCAEClass.idCustomer}`);
            this.crmCache.invalidate(`cust_detail:${customerCAEClass.idCustomer}`);
          }
        }),
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaGetCustomerCAE(idCustomer: number, options?: CrmSwrOptions): Observable<CustomerCAEClass[]> {
    return this.crmCache.swr(
      `cust_cae:${idCustomer}`,
      () =>
        this.http.get<CustomerCAEClass[]>(environment.URL + `/Customer/ClientAreaGetCustomerCAE/${idCustomer}`).pipe(
          catchError(error => {
            const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
            return throwError(() => errorMessage);
          }),
        ),
      { persist: false, silentPrefetch: true, ...options },
    );
  }

  ClientAreaCheckDataclient(idCustomer: number): Observable<Alert[]> {
    return this.http.get<Alert[]>(environment.URL + `/Customer/ClientAreaCheckDataclient/${idCustomer}`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  ClientAreaSetCustomerFilesDriveLicense(files: FilesClass): Observable<FilesClass[]> {
    return this.http
      .post<FilesClass[]>(environment.URL + `/Customer/ClientAreaSetCustomerFilesDriveLicense`, files)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaSetCustomerFilesCitizenCard(files: FilesClass): Observable<FilesClass[]> {
    return this.http
      .post<FilesClass[]>(environment.URL + `/Customer/ClientAreaSetCustomerFilesCitizenCard`, files)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaGetCustomerFilesDriveLicense(idCustomer: number): Observable<FilesClass[]> {
    return this.http
      .get<FilesClass[]>(environment.URL + `/Customer/ClientAreaGetCustomerFilesDriveLicense/${idCustomer}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaGetCustomerFilesCitizenCard(idCustomer: number): Observable<FilesClass[]> {
    return this.http
      .get<FilesClass[]>(environment.URL + `/Customer/ClientAreaGetCustomerFilesCitizenCard/${idCustomer}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetCustomerAccessHistory(idCustomer: number): Observable<any[]> {
    return this.http.get<any[]>(environment.URL + `/Customer/GetCustomerAccessHistory/${idCustomer}`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  ManagementGetCustomer(idCustomer: number): Observable<CustomerClass> {
    return this.http.get<CustomerClass>(environment.URL + `/Customer/ManagementGetCustomer/${idCustomer}`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  ManagementSetCustomer(customerClass: CustomerClass, uuid: string): Observable<CustomerClass> {
    customerClass.UUIDLastChange = uuid;
    return this.http.post<CustomerClass>(environment.URL + `/Customer/ManagementSetCustomer`, customerClass).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  ClientAreaSetCustomerContactsDefault(
    customerContactsDefault: CustomerContactsDefault,
  ): Observable<CustomerContactsDefault> {
    return this.http
      .post<CustomerContactsDefault>(
        environment.URL + `/Customer/ClientAreaSetCustomerContactsDefault`,
        customerContactsDefault,
      )
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaGetCustomerContactsDefault(idCustomer: number): Observable<CustomerContactsDefault> {
    return this.http
      .get<CustomerContactsDefault>(environment.URL + `/Customer/ClientAreaGetCustomerContactsDefault/${idCustomer}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaSetCustomerContacts(
    customerContactsClass: CustomerContactsClass,
    uuid: string,
  ): Observable<CustomerContactsClass> {
    customerContactsClass.UUIDLastChange = uuid;

    return this.http
      .post<CustomerContactsClass>(environment.URL + `/Customer/ClientAreaSetCustomerContacts`, customerContactsClass)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaGetCustomerContacts(idCustomer: number, idCompanie: number): Observable<CustomerContactsClass[]> {
    return this.http
      .get<
        CustomerContactsClass[]
      >(environment.URL + `/Customer/ClientAreaGetCustomerContacts/${idCustomer}/${idCompanie}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaSetCustomer(customerClass: CustomerClass, uuid: string): Observable<CustomerClass> {
    customerClass.UUIDLastChange = uuid;
    if (!customerClass.MyManager || typeof customerClass.MyManager !== 'string' || !customerClass.MyManager.trim()) {
      customerClass.MyManager = '[]';
    }
    if (customerClass?.idCustomer) {
      this.crmCache.invalidate(`cust_detail:${customerClass.idCustomer}`);
      this.crmCache.invalidate(`cust_nib:${customerClass.idCustomer}`);
    }
    this.crmCache.invalidate('cust_all_list');

    return this.http.post<CustomerClass>(environment.URL + `/Customer/ClientAreaSetCustomer`, customerClass).pipe(
      tap((resp: any) => {
        const returned = Array.isArray(resp) ? resp[0] : resp;
        const id = customerClass?.idCustomer || returned?.idCustomer;
        if (id) {
          this.crmCache.invalidate(`cust_detail:${id}`);
          this.crmCache.invalidate(`cust_nib:${id}`);
        }
        this.crmCache.invalidate('cust_all_list');
      }),
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  ClientAreaGetCustomer(idCustomer: number, options?: CrmSwrOptions): Observable<CustomerClass[]> {
    return this.crmCache.swr(
      `cust_detail:${idCustomer}`,
      () =>
        this.http.get<CustomerClass[]>(environment.URL + `/Customer/ClientAreaGetCustomer/${idCustomer}`).pipe(
          catchError(error => {
            const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
            return throwError(() => errorMessage);
          }),
        ),
      { persist: false, silentPrefetch: true, ...options },
    );
  }

  // GetCustomer(idCustomer: number): Observable<CustomerClass[]> {
  //   return this.http.get<CustomerClass[]>(environment.URL + `/Customer/GetCustomer/${idCustomer}`)
  //     .pipe(
  //       catchError(error => {
  //         this.httpclienterrorService.getServerErrorMessage(error);
  //       return throwError(() => error);
  //       })
  //     );
  // }

  ClientAreaGetCustomerNIF(NIF: string): Observable<CustomerClass[]> {
    return this.http.post<CustomerClass[]>(environment.URL + `/Customer/ClientAreaGetCustomerNIF`, { NIF: NIF }).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  ClientAreaGetCustomerUser(idUser: number): Observable<CustomerClass[]> {
    return this.http.get<CustomerClass[]>(environment.URL + `/Customer/ClientAreaGetCustomerUser/${idUser}`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  // GetCustomerUser(idUser: number): Observable<CustomerClass[]> {
  //   return this.http.get<CustomerClass[]>(environment.URL + `/Customer/GetCustomerUser/${idUser}`)
  //     .pipe(
  //       catchError(error => {
  //         this.httpclienterrorService.getServerErrorMessage(error);
  //       return throwError(() => error);
  //       })
  //     );
  // }

  GetCustomerALL(options?: CrmSwrOptions): Observable<CustomerClass[]> {
    return this.crmCache.swr(
      'cust_all_list',
      () =>
        this.http.get<CustomerClass[]>(environment.URL + `/Customer/GetCustomerALL`).pipe(
          catchError(error => {
            const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
            return throwError(() => errorMessage);
          }),
        ),
      options,
    );
  }

  ClientAreaGetCustomerShipToAddress(idCustomer: number): Observable<CustomerShipToAddressClass[]> {
    return this.http
      .get<CustomerShipToAddressClass[]>(environment.URL + `/Customer/ClientAreaGetCustomerShipToAddress/${idCustomer}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ClientAreaSetCustomerShipToAddress(
    customerShipToAddressClass: CustomerShipToAddressClass,
    uuid: string,
  ): Observable<CustomerShipToAddressClass> {
    // tslint:disable-next-line:object-literal-shorthand
    customerShipToAddressClass.UUIDLastChange = uuid;
    return this.http
      .post<CustomerShipToAddressClass>(
        environment.URL + `/Customer/ClientAreaSetCustomerShipToAddress`,
        customerShipToAddressClass,
      )
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  CommercialAreaGetCustomerAll(idCommercial: number): Observable<CustomerClass[]> {
    return this.http
      .get<CustomerClass[]>(environment.URL + `/Customer/CommercialAreaGetCustomerAll/${idCommercial}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  // Método para obter as preferências do utilizador
  GetCustomerInsurancePolicyPreferences(userId: number): Observable<any> {
    return this.http.get<any>(environment.URL + `/Customer/GetCustomerInsurancePolicyPreferences/${userId}`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  // Método para definir as preferências do utilizador
  SetCustomerInsurancePolicyPreferences(userId: number, selectedState: string, uuid: string): Observable<any> {
    return this.http
      .post(environment.URL + '/Customer/SetCustomerInsurancePolicyPreferences', {
        idUser: userId,
        selectedState: selectedState,
        UUID: uuid,
        UUIDLastChange: uuid,
      })
      .pipe(
        catchError(error => {
          // Tratamento de erros centralizado
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => new Error(errorMessage));
        }),
      );
  }

  spSetCustomerContactMethods(
    customerContact: CustomerContactMethodsClass,
    uuid: string,
  ): Observable<CustomerContactMethodsClass> {
    customerContact.UUIDLastChange = uuid;

    return this.http
      .post<CustomerContactMethodsClass>(
        environment.URL + `/Customer/ClientAreaSetCustomerContactMethods`,
        customerContact,
      )
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  spGetCustomerContactMethods(idCustomer: number): Observable<CustomerContactMethodsClass[]> {
    return this.http
      .get<
        CustomerContactMethodsClass[]
      >(environment.URL + `/Customer/ClientAreaGetCustomerContactMethods/${idCustomer}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  // =============================================
  // MÉTODOS PÚBLICOS (sem autenticação)
  // Para uso na home pública quando não há sessão
  // =============================================

  /**
   * Verifica se um NIF já existe na base de dados (endpoint público)
   * @param nif NIF a verificar
   * @returns { exists: boolean, nif: string }
   */
  publicCheckNif(nif: string): Observable<{ exists: boolean; nif: string }> {
    return this.http.get<{ exists: boolean; nif: string }>(environment.URL + `/Customer/public/check-nif/${nif}`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  /**
   * Regista um novo cliente de forma pública (endpoint público, sem autenticação)
   * @param customerData Dados do cliente a criar
   * @returns Dados do cliente criado + password temporária
   */
  publicRegister(customerData: {
    NIF: string;
    Name: string;
    Email: string;
    Contact: string;
    AddressDetail?: string;
    PostalCode?: string;
    Region?: string;
    Birthdate?: Date;
    idSexTypes?: number;
  }): Observable<{
    success: boolean;
    customer: { idCustomer: number; idUser: number; Name: string; Email: string; NIF: string; Contact: string };
    tempPassword: string;
    message: string;
  }> {
    return this.http
      .post<{
        success: boolean;
        customer: { idCustomer: number; idUser: number; Name: string; Email: string; NIF: string; Contact: string };
        tempPassword: string;
        message: string;
      }>(environment.URL + `/Customer/public/register`, customerData)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetCustomerRedFlagTypes(): Observable<CustomerRedFlagTypeClass[]> {
    return this.http.get<CustomerRedFlagTypeClass[]>(environment.URL + `/Customer/GetCustomerRedFlagTypes`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  SetCustomerRedFlagTypes(redFlagType: CustomerRedFlagTypeClass, uuid: string): Observable<CustomerRedFlagTypeClass[]> {
    redFlagType.UUIDLastChange = uuid;
    return this.http
      .post<CustomerRedFlagTypeClass[]>(environment.URL + `/Customer/SetCustomerRedFlagTypes`, redFlagType)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetCustomerRedFlags(idCustomer: number): Observable<CustomerRedFlagClass[]> {
    return this.http.get<CustomerRedFlagClass[]>(environment.URL + `/Customer/GetCustomerRedFlags/${idCustomer}`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  SetCustomerRedFlags(redFlag: CustomerRedFlagClass, uuid: string): Observable<CustomerRedFlagClass[]> {
    redFlag.UUIDLastChange = uuid;
    return this.http.post<CustomerRedFlagClass[]>(environment.URL + `/Customer/SetCustomerRedFlags`, redFlag).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  /** Obtém contas que partilham o mesmo telemóvel com AllowWhatsApp */
  GetWhatsAppSharedAccess(idCustomer: number): Observable<any[]> {
    return this.http.get<any[]>(environment.URL + `/Customer/GetWhatsAppSharedAccess/${idCustomer}`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }
}
